module.exports = __webpack_public_path__ + "img/19_31.b4ba38aa.png";